import React from "react";
import { Button } from "@mui/material";

interface AddSubquestionButtonProps {
  onClick: () => void;
}

export default function AddSubquestionButton({ onClick }: AddSubquestionButtonProps) {
  return (
    <Button variant={"text"} onClick={onClick}>
      Добавить подзадачу
    </Button>
  );
}
